import Lottie from 'lottie-react';
import { FC } from 'react';
import styles from './index.module.scss';
import pointJSON from '@assets/lottie/vault/point.json';
import { useVaultPortfolio } from '@hooks/use-vault-portfolio';
import { numericFormat } from '@utils/index';
import Dialog from '@ui/parrot/dialog';
import PointLink from '@components/point-link';
import { useToggle } from 'react-use';
import { type MyVaultsStruct } from '@models/myvault.model';
// import { useVaultCoins } from '@hooks/use-coins';
// import { BN, Decimal } from 'parrot-sui-sdk';
// import { ClmmPoolUtil, TickMath } from '@cetusprotocol/cetus-sui-clmm-sdk';
// import { scaleDown } from '@utils/math';
import { useVaultPoint } from '@hooks/use-vault-point';

interface OwnProps {
  myVaults: MyVaultsStruct[] | undefined;
}

const EarnRevenueNumber: FC<OwnProps> = ({ myVaults }) => {
  const { portfolio } = useVaultPortfolio();
  const { point } = useVaultPoint();
  const [visible, toggleVisible] = useToggle(false);
  // const { coins } = useVaultCoins();
  // let portfolio_usd = new Decimal(0);

  // myVaults?.forEach((item) => {
  //   const coinA = coins.find((coin) => coin.coin_type === item.coin_type_a);
  //   const coinB = coins.find((coin) => coin.coin_type === item.coin_type_b);

  //   const coinAmounts = ClmmPoolUtil.getCoinAmountFromLiquidity(
  //     new BN(item.liquidity),
  //     new BN(item.current_sqrt_price),
  //     TickMath.tickIndexToSqrtPriceX64(item.tick_lower_index),
  //     TickMath.tickIndexToSqrtPriceX64(item.tick_upper_index),
  //     false,
  //   );
  //   portfolio_usd = portfolio_usd
  //     .add(scaleDown(coinAmounts.coinA.toString(), coinA?.decimals || 9).mul(coinA?.price_usd || 0))
  //     .add(scaleDown(coinAmounts.coinB.toString(), coinB?.decimals || 9).mul(coinB?.price_usd || 0));
  // });

  return (
    <>
      <div className={styles.wrapper}>
        <div>
          <div className={styles.chart_text1}>
            ${numericFormat(portfolio?.balance.toString() || '0')}
          </div>
          <div className={styles.chart_text2}>Your Portfolio</div>
        </div>
        <div className={styles.point}>
          <div>
            <div className={styles.chart_text1}>{numericFormat(point?.point || '0')}</div>
            <div className={styles.chart_text2}>Your Points</div>
          </div>
          <div>
            <Lottie
              animationData={pointJSON}
              autoplay
              loop
              className={styles.lottie}
              onClick={toggleVisible}
            />
          </div>
        </div>
      </div>
      <Dialog
        isShown={visible}
        width={400}
        onCloseComplete={toggleVisible}
        shouldCloseOnOverlayClick={true}
      >
        {({}: { close: () => void }) => <PointLink point={point} />}
      </Dialog>
    </>
  );
};

export default EarnRevenueNumber;
